import "./NavBar.css";
import { Link, useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";

export default function NavBar() {
  const [user] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    auth.signOut();
    navigate("/logged-out");
  };

  useEffect(() => {
    async function checkUserStatus() {
      if (!user) {
        setIsAdmin(false);
        setIsVerified(false);
        return;
      }

      try {
        // Check if user doc exists in Firestore (exists = verified)
        const ref = doc(db, "users", user.uid);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          // User doc exists = they're verified
          setIsVerified(true);
          
          // Check if admin
          if (snap.data().role === "admin") {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
        } else {
          // No user doc = not verified
          setIsVerified(false);
          setIsAdmin(false);
        }
      } catch (err) {
        console.error("Error checking user status:", err);
        setIsAdmin(false);
        setIsVerified(false);
      }
    }

    checkUserStatus();
  }, [user]);

  return (
    <nav className="navbar">
      <div className="nav-links">

        <Link to="/">Home</Link>

        <Link to="/usefullinks">Useful Links</Link>

        <Link to="/trails">Browse Trails</Link>

        {!user && (
          <Link to="/login" className="login-button">
            Login
          </Link>
        )}

        {user && (
          <div className="account-dropdown-wrapper">
            <button
              className="account-button"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              My Account ▾
            </button>

            {dropdownOpen && (
              <div className="account-dropdown">
                {/* Show Verify Email if not verified */}
                {!isVerified && (
                  <Link 
                    to="/verify-email" 
                    onClick={() => setDropdownOpen(false)}
                    style={{ color: "#ff3366", fontWeight: "600" }}
                  >
                    ⚠️ Verify Email
                  </Link>
                )}

                {/* Dashboard link - only if verified */}
                {isVerified && (
                  <Link 
                    to="/dashboard" 
                    onClick={() => setDropdownOpen(false)}
                  >
                    Dashboard
                  </Link>
                )}

                {/* Admin Panel - only if verified AND admin */}
                {isAdmin && isVerified && (
                  <Link to="/admin" onClick={() => setDropdownOpen(false)}>
                    Admin Panel
                  </Link>
                )}

                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}